import { EventData } from 'lib/EventLogger/Event';
import { EventType } from 'lib/EventSchema';

export default class PageViewEvent implements EventData {
  constructor(private path: string) {}

  // eslint-disable-next-line camelcase
  event_type = EventType.pageView;

  // eslint-disable-next-line camelcase
  get event_context(): Record<string, string> {
    return {
      page_name: this.path,
    };
  }
}
